<template>
  <div class="student-tag-revise">
    <el-dialog
      title="修改标签"
      :visible="dialogVisible"
      @open="dialogOpen"
      @close="dialogClose"
      width="700px"
      :close-on-click-modal="false"
      center
    >
      <div class="name-input">
        标签名称：<el-input
          style="width: 200px"
          v-model="input"
          placeholder="请输入标签名称"
        ></el-input>
      </div>
      <el-transfer
        style="display: flex; justify-content: center"
        v-model="value"
        :data="data"
        :titles="['未选择', '已选择']"
      ></el-transfer>
      <div class="btn-list">
        <el-button type="primary" @click="tagStudentEditSubmit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    const generateData = (_) => {
      const data = [];
      for (let i = 1; i <= 15; i++) {
        data.push({
          key: i,
          label: `备选项 ${i}`,
          disabled: i % 4 === 0,
        });
      }
      return data;
    };
    return {
      data: generateData(),
      value: [1, 4],
      input: "",
    };
  },
  inject: ["refresh"],
  methods: {
    dialogOpen() {},
    dialogClose() {
      this.$emit("update:dialogVisible", false);
    },
    tagStudentEditSubmit() {},
  },
};
</script>

<style lang="scss" scoped >
@import "./student-tag-revise.scss";
</style>